module.exports = __webpack_public_path__ + "static/media/logo.c7c76c7a.svg";